(function(angular) {
    'use strict';
    class EmptyStateController {
        constructor($translate, ContactManagerNavigationService) {
            this.$translate = $translate;
            this.ContactManagerNavigationService = ContactManagerNavigationService;
            this.addContactButtonLabel = this.$translate.instant('icm-medialist__empty-state--add-contact-button');
            this.searchContactsButtonLabel = this.$translate.instant('icm-medialist__empty-state--search-contacts-button');
        }

        addContact() {
            this.ContactManagerNavigationService.goToContactAddLanding();
        }

        goToSearchPage() {
            this.ContactManagerNavigationService.goToSearch();
        }
    }
    
    angular.module('MW.ContactManager.MediaListEmptyState', [
        'ngMaterial',
        'MW.ContactManager.ContactManagerNavigationService'
    ])
    .component('mediaListEmptyState', {
        bindings: {
            text: '@',
            subText: '@',
            includeElevio: '<'
        },
        controller: ['$translate', 'ContactManagerNavigationService', EmptyStateController],
        template: `
        <md-card class="empty-state-page mw-empty-state__wrapper">
            <md-card-content class="mw-empty-state-container">
                <mw-empty-state icon="icm:influencer-lady" icon-size="large" class="empty-state-main">
                    <mw-empty-state-text translate>{{$ctrl.text}}</mw-empty-state-text>
                    <mw-empty-state-sub-text class="description" translate>{{$ctrl.subText}}</mw-empty-state-sub-text>
                    <mw-empty-state-actions>
                        <md-button class="mw-button mw-button--outlined" ng-click="$ctrl.addContact()">{{$ctrl.addContactButtonLabel}}</md-button>
                        <md-button class="mw-button md-primary" ng-click="$ctrl.goToSearchPage()">{{$ctrl.searchContactsButtonLabel}}</md-button>
                    </mw-empty-state-actions>
                </mw-empty-state>
                <mw-empty-state ng-if="$ctrl.includeElevio" class="empty-state-footer">
                    <mw-empty-state-sub-text class="description" translate>media-relations-media-lists-empty-state__subtext</mw-empty-state-sub-text>
                    <mw-empty-state-sub-text class="guide">
                        <div>
                            <a translate href="https://help.meltwater.com/en/collections/7170073-media-relations-distribute-press-releases-organize-campaigns-and-manage-pr-relationships" target="_blank">media-relations-media-lists-empty-state__link</a>
                        </div>
                    </mw-empty-state-sub-text>    
            </md-card-content>
        </md-card>    

        `
    });
}(window.angular));
